function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.468 2.792c-.381 0-.572.156-.572.468v7.8c0 1.092.347 1.846 1.04 2.262.71.398 1.742.598 3.094.598 1.352 0 2.374-.2 3.068-.598.71-.416 1.066-1.17 1.066-2.262v-7.8c0-.312-.26-.468-.78-.468v-.468h4.16v.468c-.416 0-.624.156-.624.468v7.67c0 1.022-.148 1.872-.442 2.548-.295.658-.737 1.187-1.326 1.586-.59.398-1.326.667-2.21.806-.867.138-1.872.208-3.016.208s-2.158-.07-3.042-.208c-.867-.139-1.595-.408-2.184-.806-.59-.399-1.031-.928-1.326-1.586-.295-.676-.442-1.526-.442-2.548V3.26c0-.312-.243-.468-.728-.468v-.468h4.264v.468zM50.545 4.56c-.659 0-1.317.104-1.976.312-.659.208-1.257.511-1.794.91-.52.381-.944.858-1.274 1.43-.33.572-.494 1.222-.494 1.95s.165 1.378.494 1.95c.33.572.754 1.057 1.274 1.456.538.381 1.136.676 1.794.884.659.208 1.317.312 1.976.312s1.317-.104 1.976-.312c.659-.208 1.248-.503 1.768-.884.537-.399.97-.884 1.3-1.456.33-.572.494-1.222.494-1.95s-.165-1.378-.494-1.95c-.33-.572-.763-1.049-1.3-1.43-.52-.399-1.11-.702-1.768-.91-.659-.208-1.317-.312-1.976-.312zm0-2.392c.953 0 1.924.147 2.912.442.988.277 1.89.702 2.704 1.274.815.572 1.482 1.3 2.002 2.184.52.867.78 1.898.78 3.094s-.26 2.236-.78 3.12c-.52.866-1.187 1.586-2.002 2.158-.815.572-1.716.988-2.704 1.248-.988.26-1.959.39-2.912.39-.953 0-1.924-.13-2.912-.39s-1.89-.676-2.704-1.248c-.814-.572-1.482-1.292-2.002-2.158-.52-.884-.78-1.924-.78-3.12 0-1.196.26-2.227.78-3.094.52-.884 1.188-1.612 2.002-2.184.815-.572 1.716-.997 2.704-1.274.988-.295 1.959-.442 2.912-.442zM62.097 11.71l.26.13c0 .156.035.294.104.416.122.208.355.416.702.624.364.19.771.364 1.222.52.468.156.953.286 1.456.39.503.086.953.13 1.352.13.295 0 .676-.018 1.144-.052.468-.052.927-.148 1.378-.286.45-.139.84-.33 1.17-.572.33-.243.494-.564.494-.962 0-.399-.156-.694-.468-.884-.295-.19-.693-.33-1.196-.416-.485-.087-1.049-.139-1.69-.156-.624-.035-1.265-.078-1.924-.13-.659-.052-1.309-.139-1.95-.26-.624-.122-1.187-.32-1.69-.598-.485-.295-.884-.685-1.196-1.17-.294-.503-.442-1.153-.442-1.95 0-.537.121-1.066.364-1.586.26-.52.65-.98 1.17-1.378.52-.399 1.179-.72 1.976-.962.797-.26 1.733-.39 2.808-.39.919 0 1.716.07 2.392.208.676.139 1.257.286 1.742.442.503.156.919.303 1.248.442.347.139.633.208.858.208.243 0 .416-.052.52-.156l.312.208-1.794 3.25-.26-.104c-.035-.243-.104-.442-.208-.598-.139-.208-.373-.407-.702-.598-.312-.208-.685-.39-1.118-.546-.433-.156-.901-.277-1.404-.364-.503-.104-1.005-.156-1.508-.156-.381 0-.78.035-1.196.104-.399.052-.763.139-1.092.26-.33.121-.607.286-.832.494-.208.19-.312.433-.312.728 0 .416.147.728.442.936.312.208.71.364 1.196.468.503.104 1.066.173 1.69.208.641.034 1.291.078 1.95.13.659.052 1.3.147 1.924.286.641.121 1.205.33 1.69.624.502.277.901.658 1.196 1.144.312.485.468 1.118.468 1.898 0 .901-.243 1.638-.728 2.21-.468.572-1.057 1.022-1.768 1.352-.71.329-1.482.554-2.314.676-.815.104-1.577.156-2.288.156-.988 0-1.82-.052-2.496-.156-.659-.122-1.213-.26-1.664-.416-.433-.174-.78-.321-1.04-.442-.26-.139-.485-.208-.676-.208-.121 0-.234.069-.338.208l-.364-.208 1.43-3.146z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 11.636,
  height: 11.636,
  x: 3.181,
  y: 3.183,
  stroke: "#fff",
  strokeWidth: 2,
  rx: 2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 5.091,
  height: 5.091,
  x: 1,
  y: 1,
  fill: "#0C1938",
  stroke: "#fff",
  strokeWidth: 2,
  rx: 2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 5.091,
  height: 5.091,
  x: 1,
  y: 11.909,
  fill: "#0C1938",
  stroke: "#fff",
  strokeWidth: 2,
  rx: 2
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 5.091,
  height: 5.091,
  x: 11.91,
  y: 1,
  fill: "#0C1938",
  stroke: "#fff",
  strokeWidth: 2,
  rx: 2
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 5.091,
  height: 5.091,
  x: 11.91,
  y: 11.909,
  fill: "#0C1938",
  stroke: "#fff",
  strokeWidth: 2,
  rx: 2
});

function SvgGroup85(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 18,
    fill: "none",
    viewBox: "0 0 75 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup85);
export default __webpack_public_path__ + "static/media/Group 85.5dcf0388.svg";
export { ForwardRef as ReactComponent };